import axios from "../../../../../axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import PreReadDeleteConfirmation from "../../Published/Three_Dot_Popup_Box/PreReadDeleteConfirmation";
import DraftPrePopup from "./DraftPrePopup";
import NoResponse from "../../../Create_Assessment_PreRead/create_successfullPreRead/NoResponse";
import { Tooltip } from "@mui/material";
import { BookText, CalendarDays, MoreVertical } from "lucide-react";
// Here all css comes on PublishedAssessBox.css

const DraftAssessBoxPreRead = ({ filter }) => {
  const [draftDelete, setDraftDelete] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [noresponse, setNoresponse] = useState(false);
  const [isGettingData, setIsGettingData] = useState(true);
  const [deleteData, setDeleteData] = useState(null);

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  const [draftCard, setDraftCard] = useState([]);
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  useEffect(() => {
    const draftBox = async () => {
      try {
        let response = await axios.get(
          `/api/v1/homework/preRead/filterByTeacherId/${Teacher_Json}/draft?_page=1&academic_session_id=${academicSessionId}&timetable_session_id=${timeTableSessionId}` +
            `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
            `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
            `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
            `&${filter?.date && `date=${filter?.date}`}` +
            `&${filter?.time && `time=${filter?.time}`}` +
            `&${
              filter?.subjectId?.length !== 0 &&
              `subjectId=${filter?.subjectId}`
            }`,
        );
        if (response?.data.data.length === 0) {
          setNoresponse(true);
        }
        setDraftCard(response.data.data);
      } catch (e) {
        console.log(e);
      } finally {
        setIsGettingData(false);
      }
    };
    draftBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, isDeleted]);

  function shortenParagraph(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength).trim() + "...";
  }

  return draftCard && draftCard.length > 0 ? (
    <>
      {draftCard && draftCard.length > 0 && (
        <div className="container">
          <div className="row">
            {draftCard.map((draftData, idx) => (
              <div key={idx} className="col-md-3 d-flex mb-3">
                <div
                  className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4"
                  style={{
                    backgroundColor: "#FDEFE3",
                    borderTop: "2px solid #8D4B28",
                    borderRight: "4px solid #8D4B28",
                    borderBottom: "1px solid #8D4B28",
                    borderLeft: "1px solid #8D4B28",
                    borderRadius: "0.75rem",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <NavLink
                      to="/DraftQlistPreRead"
                      className="text-dark fw-semibold text-decoration-none"
                      state={{ draftPre_id: draftData?.id }}
                    >
                      {`${draftData?.standard_id?.name} - ${draftData?.section_id?.name} | `}
                      <span
                        title={draftData?.subject_id?.name}
                        className="poppins-semibold"
                      >
                        {shortenParagraph(draftData?.subject_id?.name, 30)}
                      </span>
                    </NavLink>

                    <Popup
                      trigger={
                        <MoreVertical size={18} style={{ cursor: "pointer" }} />
                      }
                      content={
                        <div className="open_publish_pre_popupBox">
                          <DraftPrePopup
                            setDeleteActivity={setDraftDelete}
                            setDeleteData={setDeleteData}
                            draftData={draftData}
                          />
                        </div>
                      }
                      on="click"
                      hideOnScroll
                      position="bottom right"
                    />
                  </div>

                  <NavLink
                    to="/DraftQlistPreRead"
                    className="text-decoration-none text-dark"
                    state={{ draftPre_id: draftData?.id }}
                  >
                    <div className="d-flex align-items-center mb-1">
                      <BookText size={16} className="me-2 text-dark" />
                      {
                        <Tooltip
                          title={draftData?.name}
                          arrow
                          placement="bottom"
                          enterDelay={200}
                          leaveDelay={100}
                        >
                          <div className="text-truncate poppins-semibold">
                            {shortenParagraph(draftData?.name, 25)}
                          </div>
                        </Tooltip>
                      }
                    </div>

                    <div
                      className="d-flex align-items-center text-muted"
                      style={{ fontSize: "0.875rem" }}
                    >
                      <CalendarDays size={16} className="me-2 text-dark" />
                      <div className="d-flex flex-column align-items-start">
                        <span className="me-1">Updated On:</span>
                        <div>
                          <span className="text-dark">
                            {moment(draftData?.updated_at).calendar(null, {
                              sameDay: "[Today]",
                              nextDay: "[Tomorrow]",
                              nextWeek: "DD/MM/YYYY",
                              lastDay: "DD/MM/YYYY",
                              lastWeek: "DD/MM/YYYY",
                              sameElse: "DD/MM/YYYY",
                            })}
                          </span>
                          <span className="text-dark">
                            &nbsp; | &nbsp;
                            {moment(draftData?.updated_at).format("h:mm A")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {draftDelete && (
        <PreReadDeleteConfirmation
          setPreSDelete={setDraftDelete}
          scheduleData={deleteData}
          setIsDeleted={setIsDeleted}
          scheduleData_id={deleteData?.id}
        />
      )}
    </>
  ) : // (
  //   <>
  //     {!noresponse && (
  //       <img
  //         className="publishAccessLoader"
  //         src="/gift/black loader.gif"
  //         alt=""
  //       />
  //     )}
  //     {noresponse && <NoResponse setNoresponse={setNoresponse} />}
  //   </>
  // );
  isGettingData ? (
    <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
  ) : (
    <div className="d-flex justify-content-center align-items-center w-100">
      <span
        className="badge bg-light text-dark  rounded-pill px-4 py-3"
        style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
      >
        📭 Pre-Read Not Found
      </span>
    </div>
  );
};

export default DraftAssessBoxPreRead;
